/* =====================================================
   ACCORDION.JS — Open/close FAQ items
   ===================================================== */

(function () {
  function initAccordion(container) {
    const items = container.querySelectorAll('.accordion__item');

    items.forEach(function (item) {
      const trigger = item.querySelector('.accordion__trigger');
      const body = item.querySelector('.accordion__body');

      if (!trigger || !body) return;

      trigger.addEventListener('click', function () {
        const isOpen = item.classList.contains('open');

        // Close all others in same accordion
        const siblings = container.querySelectorAll('.accordion__item.open');
        siblings.forEach(function (sib) {
          if (sib !== item) {
            sib.classList.remove('open');
            sib.querySelector('.accordion__trigger').setAttribute('aria-expanded', 'false');
          }
        });

        // Toggle current
        item.classList.toggle('open', !isOpen);
        trigger.setAttribute('aria-expanded', (!isOpen).toString());
      });

      // Keyboard support
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          trigger.click();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    document.querySelectorAll('.accordion').forEach(initAccordion);
  }
})();
